import type { PosRevenueReportComponentProps } from './PosRevenueReportComponent';

export const PosRevenueReportComponent = {
    MountAsync: async (target: HTMLElement, props: PosRevenueReportComponentProps) => {
        const { mountReactComponentAsync } = await import('../../../js/mountReactComponentAsync');
        const { PosRevenueReportComponent } = await import('./PosRevenueReportComponent');
        return await mountReactComponentAsync(target, PosRevenueReportComponent, props);
    }
};
